import { Component, OnDestroy, ViewChild, OnInit, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormService } from '../../service/FormService';
import { MatDialog } from '@angular/material';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RestrictedEmailComponent } from './restricted-email/restricted-email.component';
import { SuccessSignupComponent } from './success-signup/success-signup.component';
import { Router } from '@angular/router';
import { UserAuthentication } from '../../service/restAngular/user-authentication';
import { RestAngularConfig } from '../../service/restAngular/rest-angular-config';
import { User } from '../../models/user';
import { RememberMeService } from '../../service/remember-me.service';
import {DialogState, ScrollBarData} from "../shared/scroll-bar-data";
import {AuthGuard} from "../../service/auth-guard.service";
import {ListOfPopularDomains} from "./list-of-popular-domains";

@Component({
  selector: 'app-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.css'],
  providers: [FormService, UserAuthentication, RestAngularConfig]
})
export class LoginSignupComponent implements OnDestroy, OnInit {

  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('signupForm') signUpForm: NgForm;
  user = {
    email: '',
    password: ''
  };

  newUser = {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    'g-recaptcha-response': ''
  };

  loginFailed = false;
  existingEmail = false;
  isSubmitted = false;
  rememberMe = false;
  isCapslockOn = false;
  emailDoesNotExist = false;
  popoliarEmail: boolean;
  agreeTermsAndConditions = false;

  constructor(private formService: FormService,
              private dialog: MatDialog,
              private router: Router,
              private rememberMeService: RememberMeService,
              private userAuthentication: UserAuthentication,
              private listOfPopularDomains: ListOfPopularDomains) {
    const isLoggedIn = localStorage.getItem('isLoggedIn') || AuthGuard.readCookie('isLoggedIn');
    if (isLoggedIn) this.router.navigateByUrl('/home');
    document.body.classList.add('login');
  }

  ngOnInit() {
    this.userAuthentication.redirectIfLoggedIn();
    if (this.rememberMeService.getCredentials()) {
      this.populateForm();
    }
  }
  private readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  private writeCookie(key, value) {
    document.cookie = `${key}=${value}; UTC; path=/`;
  }

  ngOnDestroy() {
    document.body.classList.remove('login');
  }

  logIn() {
    this.formService.setTouched(this.loginForm);
    if (!this.loginForm.valid) return;
    const data = this.userAuthentication.signIn({
      'username': this.user.email,
      'password': this.user.password
    });
    data.subscribe((res) => {
      RestAngularConfig.RestangularProvider.setDefaultHeaders({'Authorization': 'JWT ' + res.token});
      if (this.rememberMe) {
        localStorage.setItem('AuthToken', res.token);
        localStorage.setItem('email', res.email);
        localStorage.setItem('isLoggedIn', '1');
        this.rememberMeService.setCredentials({
          '__email__': this.user.email,
          '__password__': this.user.password
        });
      } else {
        this.writeCookie('AuthToken', res.token);
        this.writeCookie('email', res.email);
        this.writeCookie('isLoggedIn', 1);
        this.rememberMeService.setCredentials(null);
      }
      User.setUser(res);
      this.router.navigateByUrl('/home');
    });
    RestAngularConfig.RestangularProvider.addErrorInterceptor((resp) => {
      // if (!navigator.onLine || resp.status === 0) {
          //this.router.navigateByUrl('error');
        // }
      if (resp.status >= 400) {
        if (resp.text().indexOf('Email does not exists') > -1) {
          this.emailDoesNotExist = true;
        } else {
          this.loginFailed = true;
        }
      }
    });
  }

  signUp() {
    this.popoliarEmail = this.listOfPopularDomains.isPopularEmail(this.newUser.email);
    if(this.popoliarEmail) {
      //noinspection TypeScriptValidateTypes
      this.dialog.open(RestrictedEmailComponent, {data: 'Please use your company email to register. If you don\'t have one, please contact our customer service.'});
      return false;
    }

    if(this.listOfPopularDomains.isRestrictedEmail(this.newUser.email)) {
      //noinspection TypeScriptValidateTypes
      this.dialog.open(RestrictedEmailComponent, {data: 'Please contact our customer service for further assistance.'});
      return false;
    }
    this.formService.setTouched(this.signUpForm);
    this.isSubmitted = true;
    if (!this.signUpForm.valid || !this.agreeTermsAndConditions) return;
    this.userAuthentication.register(this.newUser).subscribe(() => {
      const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
      const matDialogRef = this.dialog.open(SuccessSignupComponent);
      ScrollBarData.updateBodyWidth(DialogState.OPEN, hasScrollbar);
      matDialogRef.afterClosed().subscribe(() => ScrollBarData.updateBodyWidth(DialogState.CLOSE));
    });
    RestAngularConfig.RestangularProvider.addErrorInterceptor((resp) => {
      if (resp.status >= 400) {
        if (resp.text().indexOf('This field must be unique.') > -1) {
          this.existingEmail = true;
        }
      }
    });
  }

  comparePasswords() {
    if (this.signUpForm.controls['newUser.password'].value !== this.signUpForm.controls['newUser.confirmPassword'].value){
      this.signUpForm.controls['newUser.confirmPassword'].setErrors({notMatch: true});
      return false;
    }
    return true;
  }

  forgotPassword() {
    const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
    const matDialogRef = this.dialog.open(ForgotPasswordComponent);
    ScrollBarData.updateBodyWidth(DialogState.OPEN, hasScrollbar);
    matDialogRef.afterClosed().subscribe(() => ScrollBarData.updateBodyWidth(DialogState.CLOSE));
  }

  updateForm() {
    this.isSubmitted = false;
    this.existingEmail = false;
    this.loginFailed = false;
    this.isCapslockOn = false;
    this.emailDoesNotExist = false;
  }

  // rcaptcharesolved(captchaResponse: string) {
  //   this.newUser['g-recaptcha-response'] = captchaResponse;
  // }

  populateForm(): void {
    this.user.email = this.rememberMeService.getCredentials().__email__;
    this.user.password = this.rememberMeService.getCredentials().__password__;
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/login-signup/login-signup.component.ts